import React, { Component } from 'react';
import axios from 'axios'
import { BrowserRouter, Route,  Navigate } from 'react-router-dom'

import { Panel } from 'primereact/panel';

import Server from './../Server.js'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { confirmAlert } from 'react-confirm-alert';
import { AutoComplete } from 'primereact/autocomplete';
import { Chip } from 'primereact/chip';
import { connect } from 'react-redux';
import { Loader } from 'rsuite';
import { Toast } from "primereact/toast";
import {Multiselect} from 'multiselect-react-dropdown';

class SetDeposit extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();


    this.CreateForm = this.CreateForm.bind(this);

    this.state = {
      layout: 'list',
      name: "",
      ShopsList: [],
      type: "1",
      FId: "",
      usersList: [],
      done: false

    }


  }
  
  componentDidMount() {
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1
    })
    let that = this;

    let SCallBack = function (response) {
      that.setState({
        user_Id: response.data.authData.userId,
        username: response.data.authData.username,
        loading: 0
      })
      that.getFishList();

    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0
      })
      console.log(error)
    }
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack)
  }
  
  CreateForm() {
    this.setState({
      visibleManageField: true,
      fTitle: "",
      enable: true,
      lTitle: "",
      father: "",
      usersList: [],
      system:null,
      selectedId: null
    })

  }
  
  selectedComponentChange(value) {
    let that = this;
    var p = [];
    this.setState({
      fTitle: value.fTitle,
      lTitle: value.lTitle,
      father: value.father,
      enable: value.enable,
      usersList: value.usersList,
      system: value.system,
      selectedId: value._id,
      visibleManageField: true
    })
  }
  getFishList(done) {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      done: done||false,
      GetAll: 1
    };
    this.setState({
      loading: 1
    })
    let SCallBack = function (response) {
      that.setState({
        GridDataFields: response.data.result
      })
      that.setState({
        loading: 0
      })
    };
    let ECallBack = function (error) {
      console.log(error)
      that.setState({
        loading: 0
      })
    }
    this.Server.send("AdminApi/getFish", param, SCallBack, ECallBack)
  }
  updateFish(_id,check){
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      done: check||false,
      _id: _id
    };
    this.setState({
      loading: 1
    })
    let SCallBack = function (response) {
      that.getFishList(that.state.done||false)
      that.setState({
        loading: 0
      })
    };
    let ECallBack = function (error) {
      console.log(error)
      that.setState({
        loading: 0
      })
    }
    this.Server.send("AdminApi/updateFish", param, SCallBack, ECallBack)

  }
  delField(rowData) {
    this.setState({
      visibleManageField: false
    })
    confirmAlert({
      title: <span className="yekan">حذف کاربر</span>,
      message: <span className="yekan">  آیا از حذف  {rowData.name} مطمئنید  </span>,
      buttons: [
        {
          label: <span className="yekan">بله </span>,
          onClick: () => {
            let that = this;
            let param = {
              token: localStorage.getItem("api_token"),
              _id: rowData._id
            };
            let SCallBack = function (response) {
              that.setState({
                loading: 0
              })
              that.getSessionList();
             that.toast.current.show({severity:'success', summary: '', detail:'عملیات با موفقیت انجام شد', life: 3000});
            };
            let ECallBack = function (error) {
              that.setState({
                loading: 0
              })
              that.toast.current.show({severity:'error', summary: 'خطای سرور', detail:'عملیات انجام نشد', life: 3000});
            }
            this.Server.send("MainApi/delSessionList", param, SCallBack, ECallBack)

          }
        },
        {
          label: <span className="yekan">خیر </span>
        }
      ]
    });

  }
  render() {
    const checkTemplate = (rowData, props) => {
      return <Checkbox inputId="ShowPriceAftLogin"  checked={rowData.done} onChange={e => 
        {
          
          this.updateFish(rowData._id,!rowData.done)

        }
      }></Checkbox>
    }
    const picTemplate = (rowData, props) => {
      return <img src={rowData.Fish_Pic} style={{height:100}} />
    }
    const priceTemplate = (rowData, props) => {
      return <span>{rowData.Amount ? rowData.Amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0}</span>
    }


    
    return (

      <div style={{ direction: 'rtl' }}>
        {this.state.loading == 1 &&
          <div style={{ position: 'fixed', zIndex: 2000, top: 10, left: 15, backgroundColor: '#e89f31', padding: '2px 20px' }}>
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        }
        <div className="row justify-content-center mt-2">

          <div className="col-12" style={{ background: '#fff' }}>
          <div>
              <div>
                <div className="group">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end",
                    }}
                  >
                    <Checkbox
                      inputId="active"
                      value={this.state.done}
                      checked={this.state.done}
                      onChange={(e) => {
                        this.setState({ done: e.checked });
                        this.getFishList(e.checked);
                      }}
                    ></Checkbox>
                    <label
                      htmlFor="active"
                      className="p-checkbox-label yekan"
                      style={{ paddingRight: 5, marginBottom: 0 }}
                    >
                      {this.state.done ? "انجام شده" : "انجام نشده"}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <Panel header="لیست واریزی ها" style={{ textAlign: 'right', fontFamily: 'yekan' }}>
             
              <DataTable responsive value={this.state.GridDataFields} selectionMode="single" selection={this.state.selectedComponent} onSelectionChange={e => this.selectedComponentChange(e.value)}>
                <Column field="del" body={checkTemplate} header="انجام شده" className="irsans" style={{ textAlign: "right" }} />

                <Column field="name" header="نام" className="irsans" style={{ textAlign: "right" }} />
                <Column field="mobile" header="موبایل" className="irsans" style={{ textAlign: "right" }} />
                <Column field="CodeMelli" header="کدملی/شماره حساب" className="irsans" style={{ textAlign: "right" }} />
                <Column field="FishDate" header="تاریخ فیش" className="irsans" style={{ textAlign: "right" }} />
                <Column field="fishBank" header="بانک" className="irsans" style={{ textAlign: "right" }} />
                <Column field="Amount" body={priceTemplate} header="مبلغ" className="irsans" style={{ textAlign: "right" }} />
                <Column field="Fish_Pic" body={picTemplate} header="تصویر فیش" className="irsans" style={{ textAlign: "right" }} />
              </DataTable>
            </Panel>
          </div>

        </div>


      </div>





    )
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  }
}
export default connect(mapStateToProps)(SetDeposit)
